import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "../components/Button";
import { useModalStore } from "../hooks/useModalStore";
import { useStore } from "../hooks/useStore";

export function Landing() {
  const { t } = useTranslation("landing");
  const navigate = useNavigate();
  const openInstructions = useModalStore(
    (state) => state.openInstructionsModal
  );
  const instructionsViewed = useStore((state) => state.instructionsViewed);
  const resetSessionWhenComplete = useStore(
    (state) => state.resetSessionWhenComplete
  );

  const buttonClickHandler = () => {
    resetSessionWhenComplete();
    if (instructionsViewed) {
      navigate("/play");
    } else {
      openInstructions();
    }
  };

  return (
    <div className="flex flex-col xl:pb-104px w-375px max-sm:px-4 max-xl:px-16 sm:w-full xl:min-w-1312px xl:w-1312px mx-auto">
      <div className="flex max-xl:flex-col max-xl:justify-start xl:justify-between items-center xl:py-8 font-sans xl:min-h-451px w-full">
        <div
          className={`xl:hidden w-263px max-h-206px sm:w-343px sm:max-h-269px flex items-center justify-center overflow-hidden`}
        >
          <img
            src="images/landing-embryo.webp"
            alt="Embryo Illustration"
            className="h-206px sm:h-268px w-auto translate-y-[-20]"
          />
        </div>
        <div
          className={`flex flex-col justify-center w-343px sm:w-full xl:w-664px xl:h-451px`}
        >
          <div className="text-left text-12 leading-66px font-700 text-tinkerTots-black xl:pt-4">
            {t("title")}
          </div>
          <div className="text-left sm:text-6 leading-6 sm:leading-8 text-tinkerTots-black pt-4">
            {t("description")}
          </div>
          <div className="flex pt-6 max-xl:pb-6">
            <Button
              className="h-57px w-353px"
              onClick={buttonClickHandler}
              text={t("primary-action-label")}
            />
          </div>
        </div>
        <div className="max-xl:hidden w-24px h-full" />
        <div
          className={`max-xl:hidden w-595px xl:max-h-451px overflow-hidden flex justify-center`}
        >
          <img
            src="images/landing-embryo.webp"
            alt={t("image-alt")}
            className="h-451px w-auto"
          />
        </div>
      </div>
      <div className="flex max-xl:flex-col max-xl:pt-4 xl:justify-between items-center w-full">
        <div className="xs:h-351px xl:w-624px rounded-2 overflow-hidden flex justify-center items-center">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube-nocookie.com/embed/vFH_CS2Z5Z8?si=9-Bfs77BT2HsHaOK&amp;controls=1&amp;loop=1&amp;playlist=vFH_CS2Z5Z8"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
        <div className="flex flex-col xl:w-636px max-xl:pt-8 max-xl:pb-24">
          <div className="w-full">
            <div className="font-700 text-6 leading-8">{t("header-1")}</div>
            <div className="w-full h-2" />
            <div className="leading-6">{t("paragraph-1")}</div>
          </div>
          <div className="w-full h-8 xl:h-6" />
          <div className="w-full">
            <div className="font-700 text-6 leading-8">{t("header-2")}</div>
            <div className="w-full h-2" />
            <div className="leading-6">{t("paragraph-2")}</div>
          </div>
        </div>
      </div>
      <div className="flex max-xl:flex-col justify-center items-center w-full max-xl:pb-15 xl:py-30">
        <a href="https://www.ox.ac.uk" target="_blank" rel="noreferrer">
          <img
            className="max-h-36 w-auto xl:px-10 max-xl:py-5"
            src="images/collaborators/Oxford.png"
            alt={t("collaborators-alt-1")}
          />
        </a>
        <a href="https://www.nus.edu.sg/" target="_blank" rel="noreferrer">
          <img
            className="max-h-36 w-auto xl:px-10 max-xl:py-5"
            src="images/collaborators/NUS.jpg"
            alt={t("collaborators-alt-2")}
          />
        </a>
        <a href="https://www.exeter.ac.uk/" target="_blank" rel="noreferrer">
          <img
            className="max-h-36 w-auto xl:px-10 max-xl:py-5"
            src="images/collaborators/Exeter.png"
            alt={t("collaborators-alt-3")}
          />
        </a>
        <a href="https://www.antitheses.net/" target="_blank" rel="noreferrer">
          <img
            className="max-h-36 w-auto xl:px-10 max-xl:py-5"
            src="images/collaborators/Antitheses.png"
            alt={t("collaborators-alt-4")}
          />
        </a>
        <a
          href="https://wellcome.org/what-we-do/our-work/directed-funding"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="max-h-36 w-auto xl:px-10 max-xl:py-5"
            src="images/collaborators/Wellcome-funded by.png"
            alt={t("collaborators-alt-5")}
          />
        </a>
      </div>
    </div>
  );
}
